import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const validTabs = new Set(['guide', 'rootVehicle', 'filters', 'insights']);

export const useTabNavigation = (id: string | undefined) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') || 'guide';
  
  const [activeTab, setActiveTab] = useState<string>(() => {
    const fromSearch = validTabs.has(tabParam) ? tabParam : null;
    const storageKey = `guide:${id}:tab`;
    const fromStorage = typeof window !== 'undefined' ? localStorage.getItem(storageKey) : null;
    return (fromSearch || (fromStorage && validTabs.has(fromStorage) ? fromStorage : 'guide')) as string;
  });

  useEffect(() => {
    const current = searchParams.get('tab') || 'guide';
    if (validTabs.has(current) && current !== activeTab) {
      setActiveTab(current);
    }
  }, [searchParams, activeTab]);

  useEffect(() => {
    const storageKey = `guide:${id}:tab`;
    try {
      localStorage.setItem(storageKey, activeTab);
    } catch {
      // Ignore localStorage errors (e.g. in private browsing mode)
    }
    const current = searchParams.get('tab');
    if (current !== activeTab) {
      setSearchParams({ tab: activeTab }, { replace: true });
    }
  }, [activeTab, id, searchParams, setSearchParams]);

  const changeTab = (key: string) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  return {
    activeTab,
    changeTab,
  };
};